// DEPENDENCIES
import React, { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { useFormik } from "formik";
import { useParams } from 'react-router';
// COMPONENTS
import { Form } from "react-bootstrap";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import Select from 'react-select'
// CUSTOM COMPONENTS
import * as alert from "../../../redux/alertSnackBarRedux";
// SERVICES AND HELPERS
import { getInputClasses, setToOptionModel } from "../../../helpers/helper";
import CredentialValidator from "../../../helpers/validators/CredentialValidator";
import * as trainingTypeService from "../../../services/companyData/trainingTypeService";
import * as intervalTypeService from "../../../services/companyData/intervalTypeService";
import * as credentialService from "../../../services/training/credentialService";
import * as trainingSubTypeService from '../../../services/companyData/trainingSubTypeService';

const CredentialDetailPage = (props) => {
    var { credentialId } = useParams();

    var initialValues = {
        id: credentialId,
        name: "",
        frequency: "",
        description: "",
        trainingTypeId: 0,
        trainingSubTypeId: null,
        intervalTypeId: 0,
        isArchived: false
    }
    const { showAlert, history } = props;
    const [loading, setloading] = useState(false);
    const [savedCredentialValue, setSavedCredentialValue] = useState(initialValues);
    const [trainingList, setTrainingList] = useState([]);
    const [intervalList, setIntervalList] = useState([]);
    const [selectedTraining, setSelectedTraining] = useState(null);
    const [selectedInterval, setSelectedInterval] = useState(null);
    const [subTrainingList, setSubTrainingList] = useState([]);
    const [selectedSubType, setSelectedSubType] = useState(null);
    const [archivedType, setArchivedType] = useState('');
    const [archivedSubType, setArchivedSubType] = useState('');


    useEffect(() => {
        loadSelectOptions();
    }, []);

    const loadSelectOptions = async () => {
        const trainingList = await trainingTypeService.getTrainingTypes(false).then(trainings => {
            setTrainingList(trainings);
            return trainings;
        });
        const intervalList = await intervalTypeService.getIntervalTypes().then(intervals => {
            setIntervalList(intervals);
            return intervals;
        });
        if (initialValues.id != 0) {
            await setSavedFormValues(trainingList, intervalList);
        }
    }

    const setSavedFormValues = async (trainingList, intervalList) => {
        await credentialService.getCredentialById(initialValues.id)
            .then(savedCredential => {
                setSavedCredentialValue(savedCredential);
                let intervalSelected = intervalList.find(x => x.id == savedCredential.intervalTypeId);
                if (intervalSelected)
                    setSelectedInterval(setToOptionModel(intervalSelected.name, intervalSelected.id));

                if (savedCredential.isArchived) {
                    //Get Training Name
                    trainingTypeService.getTrainingTypeById(savedCredential.trainingTypeId).then(res => {
                        setArchivedType(res.name);
                    })

                    if (savedCredential.trainingSubTypeId) {
                        //Get Training Sub Name
                        trainingSubTypeService.getTrainingSubTypeById(savedCredential.trainingSubTypeId).then(res => {
                            setArchivedSubType(res.name);
                        })
                    }

                } else {
                    let trainingSelected = trainingList.find(x => x.id == savedCredential.trainingTypeId);
                    if (trainingSelected) {
                        setSelectedTraining(setToOptionModel(trainingSelected.name, trainingSelected.id));
                        fetchTrainingSubTypeList(trainingSelected.id, savedCredential.trainingSubTypeId);
                    }
                }
            })
    }

    const fetchTrainingSubTypeList = (trainingTypeId, selectedSubTypeId) => {
        trainingSubTypeService.getTrainingSubTypes(trainingTypeId, false).then(subTypes => {
            setSubTrainingList(subTypes);
            if (selectedSubTypeId) {
                let subTypeSelected = subTypes.find(x => x.id == selectedSubTypeId);

                setSelectedSubType(setToOptionModel(subTypeSelected.name, subTypeSelected.id));
            }
        })
    }

    const createCredentialHandler = (values, setStatus, setSubmitting) => {
        setSubmitting(true);
        setloading(true);
        credentialService.saveCredential(values).then(res => {
            props.history.push("/training/credentials");
            showAlert({ message: res.message, variant: "success" });
        }).catch(ex => {
            showAlert({ message: ex.message, variant: "error" });
            setSubmitting(false);
            setloading(false);
        })
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: savedCredentialValue,
        validationSchema: CredentialValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            // if (subTrainingList.length > 0 && selectedSubType == null) {
            //     showAlert({ message: "Please select a Credential Sub Type", variant: 'warning' });
            //     setSubmitting(false);
            //     return;
            // }
            createCredentialHandler(values, setStatus, setSubmitting);
        }
    });

    return (
        <form
            className="card card-custom card-stretch"
            onSubmit={formik.handleSubmit}
        >
            {loading && <ModalProgressBar />}
            <div className="card-header py-3">
                <div className="card-title align-items-start flex-column">
                    <h3 className="card-label font-weight-bolder text-dark">
                        {savedCredentialValue.id == 0 ? "Add" : "Update"} Credentials
                    </h3>
                    <span className="text-muted font-weight-bold fz-xs mt-1">
                        Please fill out the form below. Fields marked as <code>*</code> are required.
                    </span>
                </div>
                <div className="card-toolbar">
                    {
                        !savedCredentialValue.isArchived &&
                        <button
                            type="submit"
                            className={`btn btn-success mr-2`}
                            disabled={
                                formik.isSubmitting || (formik.touched && !formik.isValid)
                            }
                        >
                            {savedCredentialValue.id == 0 ? "Add" : "Save"} Credential
                        {formik.isSubmitting}
                        </button>
                    }

                    <a
                        onClick={() => history.goBack()}
                        className="btn btn-danger"
                    >
                        Cancel
                    </a>
                </div>
            </div>
            <fieldset disabled={savedCredentialValue.isArchived}>
                <div className="form">
                    <div className="card-body">
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Credential Type*
                        </label>
                            <div className="col-lg-9 col-xl-9">
                                {
                                    savedCredentialValue.isArchived ?
                                        <input className={`form-control form-control-lg form-control-solid`} value={archivedType} /> :
                                        <>
                                            <Select
                                                value={selectedTraining}
                                                options={trainingList.map(x => setToOptionModel(x.name, x.id))}
                                                onChange={selectedOption => {
                                                    setSelectedSubType(null);
                                                    fetchTrainingSubTypeList(selectedOption.value);
                                                    setSelectedTraining(selectedOption);
                                                    formik.setFieldValue("trainingTypeId", selectedOption.value);
                                                }}
                                                className={`${getInputClasses(formik, "trainingTypeId")}`}
                                                name="trainingTypeId"
                                                placeholder="Select Credential Type"
                                            />
                                            {formik.touched.trainingTypeId && formik.errors.trainingTypeId ? (
                                                <div className="invalid-feedback">
                                                    {formik.errors.trainingTypeId}
                                                </div>
                                            ) : null}
                                        </>
                                }
                            </div>
                        </div>
                        {
                            savedCredentialValue.isArchived && archivedSubType != "" ?
                                <div className="form-group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                        Credential Sub Type*
                                    </label>
                                    <div className="col-lg-9 col-xl-9">
                                        <input className={`form-control form-control-lg form-control-solid`} value={archivedSubType} />
                                    </div>
                                </div>
                                : subTrainingList.length > 0 ?
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                            Credential Sub Type*
                                        </label>
                                        <div className="col-lg-9 col-xl-9">
                                            <Select
                                                value={selectedSubType}
                                                options={subTrainingList.map(x => setToOptionModel(x.name, x.id))}
                                                onChange={selectedOption => {
                                                    setSelectedSubType(selectedOption);
                                                    formik.setFieldValue("trainingSubTypeId", selectedOption.value);
                                                }}
                                                className={`${getInputClasses(formik, "trainingSubTypeId")}`}
                                                name="trainingSubTypeId"
                                                placeholder="Select Credential Sub Type"
                                            />
                                            {formik.touched.trainingSubTypeId && formik.errors.trainingSubTypeId ? (
                                                <div className="invalid-feedback">
                                                    {formik.errors.trainingSubTypeId}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    : <></>
                        }
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Credential Name*
                        </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    type="text"
                                    placeholder="Enter Credential Name"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "name")}`}
                                    name="name"
                                    {...formik.getFieldProps("name")}
                                />
                                {formik.touched.name && formik.errors.name ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.name}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Frequency*
                        </label>
                            <div className="col-lg-9 col-xl-9">
                                <input
                                    type="number"
                                    placeholder="Enter Frequency of Credential"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "frequency")}`}
                                    name="frequency"
                                    {...formik.getFieldProps("frequency")}
                                />
                                {formik.touched.frequency && formik.errors.frequency ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.frequency}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Interval Type*
                        </label>
                            <div className="col-lg-9 col-xl-9">
                                <Select
                                    value={selectedInterval}
                                    options={intervalList.map(x => setToOptionModel(x.name, x.id))}
                                    onChange={selectedOption => {
                                        setSelectedInterval(selectedOption);
                                        formik.setFieldValue("intervalTypeId", selectedOption.value);
                                    }}
                                    className={`${getInputClasses(formik, "intervalTypeId")}`}
                                    name="intervalTypeId"
                                    placeholder="Select an Interval Type"
                                />
                                {formik.touched.intervalTypeId && formik.errors.intervalTypeId ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.intervalTypeId}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Description
                        </label>
                            <div className="col-lg-9 col-xl-9">
                                <Form.Control as="textarea" rows="5"
                                    placeholder="Start typing..."
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "description")}`}
                                    name="description"
                                    {...formik.getFieldProps("description")}
                                />

                                {formik.touched.description && formik.errors.description ? (
                                    <div className="invalid-feedback">
                                        {formik.errors.description}
                                    </div>
                                ) : null}
                            </div>
                        </div>

                    </div>
                </div>
            </fieldset>
        </form>
    )
}

export default connect(null, alert.actions)(CredentialDetailPage);